$(document).ready(function () {
  if ($('.campaign-collection').length) {
    $('[name="sort_by"]').change(function () {
      return (window.location.href = window.location.pathname + '?sort_by=' + $(this).val())
    })
  }
})
